import { Icon } from "../icons/Icon";
import "./Toast.css";

export type ToastKind = "pass" | "over-limit" | "info";

export interface ToastData {
  readonly kind: ToastKind;
  readonly message: string;
}

const ICON_BY_KIND: Record<ToastKind, "check" | "flag" | "info"> = {
  pass: "check",
  "over-limit": "flag",
  info: "info",
};

/**
 * 触れ（トースト。O-4）。帳場の直下・中央上から降りる。フォーカスを奪わない
 * （screen-flow.md §9.3）。合格・手数超過・案内の3種のみ扱う。
 */
export function Toast({ toast }: { readonly toast: ToastData }) {
  return (
    <div className={`toast toast--${toast.kind}`} role="status" aria-live="polite">
      <Icon name={ICON_BY_KIND[toast.kind]} decorative size={18} />
      <span>{toast.message}</span>
    </div>
  );
}
